var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPhoneCall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "Layer_1",
    "data-name": "Layer 1",
    viewBox: "0 -6 35 25",
    width: 20,
    height: 20,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.613,12.848l6.265,6.265-3.171,3.171A5.889,5.889,0,0,1,16.5,24C9.252,24,0,14.748,0,7.5A5.9,5.9,0,0,1,1.716,3.292L4.887.122l6.265,6.265L7.027,10.512A12.136,12.136,0,0,0,13.48,16.98ZM22,10h2A10.011,10.011,0,0,0,14,0V2A8.009,8.009,0,0,1,22,10Zm-4,0h2a6.006,6.006,0,0,0-6-6V6A4,4,0,0,1,18,10Z",
    fill: "#0c6cc5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoneCall);
export default __webpack_public_path__ + "static/media/phone-call.6d862d29308afc44dd22fb238650ada4.svg";
export { ForwardRef as ReactComponent };